// src/components/common/ScrollingBanner.jsx
import React from "react";
import { FaStar, FaLeaf, FaSeedling, FaTractor } from "react-icons/fa";
import "../../../../assets/css/customer/home/scrollBanner/ScrollBanner.css";

const ScrollBanner = () => {
  // Banner items with icons
  const bannerItems = [
    { text: "VEGETABLES", icon: FaLeaf },
    { text: "AGRICULTURE", icon: FaSeedling },
    { text: "FARMING", icon: FaTractor },
    { text: "ORGANIC", icon: FaLeaf },
    { text: "FRESH PRODUCE", icon: FaStar },
    { text: "VEGETABLES", icon: FaLeaf },
    { text: "AGRICULTURE", icon: FaSeedling },
    { text: "FARMING", icon: FaTractor },
  ];

  return (
    <div className="scrolling-banner-wrapper">
      <div className="scrolling-banner">
        <div className="scrolling-content">
          {/* First set of items */}
          {bannerItems.map((item, index) => (
            <div key={`first-${index}`} className="banner-item">
              <span className="banner-text">{item.text}</span>
              <item.icon className="banner-icon" />
            </div>
          ))}

          {/* Duplicate set for seamless loop */}
          {bannerItems.map((item, index) => (
            <div key={`second-${index}`} className="banner-item">
              <span className="banner-text">{item.text}</span>
              <item.icon className="banner-icon" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ScrollBanner;
